import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { validarCredencialQr } from '../services/socioPortalService'

export default function ValidarSocioQrPage() {
  const { token } = useParams()
  const [result, setResult] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let active = true
    validarCredencialQr(token)
      .then((data) => { if (active) setResult(data) })
      .catch(() => { if (active) setResult({ valido: false }) })
      .finally(() => { if (active) setLoading(false) })
    return () => { active = false }
  }, [token])

  if (loading) return <main className="grid min-h-dvh place-items-center bg-background text-text-secondary">Validando credencial…</main>
  const active = result?.valido && result.estado === 'activo'
  const validInactive = result?.valido && !active
  return (
    <main className="grid min-h-dvh place-items-center bg-background px-4 py-safe-page">
      <section className={'w-full max-w-lg rounded-3xl border bg-white p-5 text-center shadow-xl sm:p-7 ' + (active ? 'border-success/40' : 'border-danger/30')}>
        <img src="/logo-cpa.jpg" alt="CSPAH" className="mx-auto h-24 w-full max-w-52 object-contain" />
        {active ? <><div className="mx-auto mt-6 grid h-16 w-16 place-items-center rounded-full bg-success text-3xl text-white">✓</div><h1 className="mt-5 text-3xl font-bold text-success-text">SOCIO ACTIVO</h1><p className="mt-4 text-xl font-semibold">{result.nombre}</p><p className="mt-4 rounded-xl bg-success/10 p-3 font-semibold text-success-text">Beneficios habilitados</p><p className="mt-4 text-sm text-text-secondary">Código válido</p></> : validInactive ? <><div className="mx-auto mt-6 grid h-16 w-16 place-items-center rounded-full bg-danger text-3xl text-white">!</div><h1 className="mt-5 text-3xl font-bold text-danger">SOCIO INACTIVO</h1><p className="mt-4 text-xl font-semibold">{result.nombre}</p><p className="mt-4 rounded-xl bg-danger/10 p-3 font-semibold text-danger">Beneficios no disponibles</p><p className="mt-4 text-sm text-text-secondary">Código válido</p></> : <><div className="mx-auto mt-6 grid h-16 w-16 place-items-center rounded-full bg-danger text-3xl text-white">×</div><h1 className="mt-5 text-3xl font-bold text-danger">CREDENCIAL NO VÁLIDA</h1><p className="mt-4 text-text-secondary">El código no existe, fue revocado o ya no está disponible.</p></>}
      </section>
    </main>
  )
}